import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import { fetchUsers } from "../../../../redux/reducer/userReducer";
import UserDropdown from "../../../sharedComponents/UserDropdown";
import {
  createCartToReceived,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";

const AddCartForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { areas } = useSelector((state) => state.areas);
  const { users } = useSelector((state) => state.users);

  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [selectedUserBoxNumber, setSelectedUserBoxNumber] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [desc, setDesc] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const handleQuantityChange = (type) => {
    setQuantity((prev) => {
      if (type === "increment") {
        return prev + 1;
      } else {
        return prev > 0 ? prev - 1 : prev;
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchAreas()).unwrap();
        await dispatch(fetchUsers()).unwrap();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  // useEffect(()=>{
  //   console.log(selectedAreaId)
  //   console.log(selectedUserId)
  //   console.log(quantity)
  //   console.log(desc)
  // })

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ">
      <div className="bg-white p-6 rounded-xl w-[50%]  shadow-xl space-y-4 ">
        <h2 className="text-xl font-bold text-black">Add New Cart</h2>

        {/* Users Dropdown */}
        <UserDropdown
          users={users}
          onSelect={(selectedUser) => {
            setSelectedUserBoxNumber(selectedUser.boxNumber);
          }}
        />

        {/* Area Dropdown */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedAreaId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Area
          </option>
          {areas?.map((area) => (
            <option key={area._id} value={area._id} className="text-black">
              {area.name?.en}
            </option>
          ))}
        </select>
        <div className="flex items-center justify-between ">
          <h1 className="text-sm text-black">Number of products</h1>

          <div className="flex items-center border ">
            <button
              className={`px-4 py-2 text-black duration-300 ${
                quantity <= 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
              onClick={() => handleQuantityChange("decrement")}
              disabled={quantity <= 1}
            >
              -
            </button>
            <span className="px-4 text-black">{quantity}</span>
            <button
              className={`px-4 py-2 text-black duration-300  bg-custom-yellow hover:bg-yellow-500`}
              onClick={() => handleQuantityChange("increment")}
            >
              +
            </button>
          </div>
        </div>

        <textarea
          placeholder="Note"
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />

        <div className="flex justify-end gap-4">
          {isLoading ? null : (
            <button
              className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
          ) : (
            <button
              className="px-4 py-2 text-sm text-black duration-300 rounded-lg hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() => {
                setIsLoading(true);
                // console.log(selectedAreaId)
                // console.log(selectedUserBoxNumber)
                // console.log(quantity)
                // console.log(desc)

                dispatch(
                  createCartToReceived({
                    boxNumber: selectedUserBoxNumber,
                    area: selectedAreaId,
                    countOfProducts: quantity,
                    adminNotes: desc,
                  })
                )
                  .unwrap()
                  .then(() => {
                    //  alert("The Cart has been added successfully.");
                    dispatch(fetchAllCarts());
                  })
                  .catch((error) => {
                    alert("Failed to add the Cart: " + error);
                  })
                  .finally(() => {
                    setIsLoading(false);
                    onClose();
                  });
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCartForm;
